import { restRequest } from "vrcore-dashboard/dist/utilities";
export const GET_USERS = restRequest(
    "VRCORE_DASHBOARD_V2.USER_REPORT_TOTAL_WIDGET.GET_USERS"
);
export const GET_REPORT_TYPES = restRequest(
    "VRCORE_DASHBOARD_V2.USER_REPORT_TOTAL_WIDGET.GET_REPORT_TYPES"
);
export const SET_FROM_DATE_FILTER =
    "VRCORE_DASHBOARD_V2.USER_REPORT_TOTAL_WIDGET.SET_FROM_DATE";
export const SET_TO_DATE_FILTER =
    "VRCORE_DASHBOARD_V2.USER_REPORT_TOTAL_WIDGET.SET_TO_DATE";
